export default __webpack_public_path__ + "locales/tr/Settings.json?hash=1b76afcc850b51e5c1ec7732dd8f518f";